<template>
  <!-- youtube dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-youtube</v-icon>
          {{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.addEditYoutube'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="12" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12">
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.videoName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.pleaseFillName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12">
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.details'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.details'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.pleaseFillDetails'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="12" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12">
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.url'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="urlRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.fillURL'
                  )
                "
                v-model="url"
                @click:clear="clearPreview"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="2" lg="2" md="2" sm="12" xs="12" class="pl-0 mt-9">
              <v-btn :disabled="!url" @click="showPreview">
                <v-icon left>mdi-eye</v-icon>Preview
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" v-if="preview">
              <!-- <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertYoutube.sample'
                  )
                }}
              </p> -->
              <iframe
                v-if="isCheckComplete"
                v-show="urlID.length > 0"
                id="ytplayer"
                type="text/html"
                class="iframeWeb"
                :src="urlID"
                frameborder="0"
              />
              <!-- <iframe id="ytplayer" type="text/html" class="iframeWeb" src="https://www.youtube.com/embed/QtnHheKchbQ" frameborder="0" /> -->
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="validate"
          :disabled="!valid"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInsertYoutubeFail" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertYoutube.isId'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertYoutube.errorFillAgain'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogInsertYoutubeFail = false"
            >{{
              this.$vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertYoutube.ok'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import {
  insertLecture,
  updateLecture,
  insertYoutube,
  updateYoutube,
} from '@/service/course/course.js';

// import {getPreviewYoutube } from "@/service/course/course.js";
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {
      valid: true,

      title: '',
      description: '',
      url: '',

      maxWidth: '40%',
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertYoutube.pleaseFillName'
          ),
      ],
      urlRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertYoutube.fillURL'
          ),
      ],

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,

      // preview youtube
      preview: false,
      youtubeID: '',
      urlPreviewTemplate: 'https://www.youtube.com/embed/',
      urlID: '',
      youtube_id: '',
      dialogInsertYoutubeFail: false,
      isCheckComplete: true,
    };
  },
  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.isCheckComplete = true;
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          this.oldValue = filterLecture;

          // get youtube detail
          this.youtubeId = filterLecture.youtube[0].idyoutube;
          this.youtube_id = filterLecture.youtube[0]._id;

          // preview
          this.url = this.urlPreviewTemplate + this.youtubeId;
          this.urlID = this.urlPreviewTemplate + this.youtubeId;
          this.preview = true;
        } else {
          this.isCheckComplete = true;
          this.title = '';
          this.description = '';
          this.url = '';
          this.preview = false;
          this.youtubeID = '';
          this.urlID = '';
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
          this.oldValue = [];
          this.warnningToSaveDialog = false;
        }
      }
    },
    url(value) {
      if (value.length == 0) {
        this.clearPreview();
      } else {
        this.showPreview();
      }
    },
  },
  methods: {
    async validate() {
      this.warnningToSaveDialog = false;
      if (this.$refs.form.validate()) {
        if (!this.lectureId) {
          let resultIDYoutube = await insertYoutube({ urlyoutube: this.url });

          let result = await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            youtube: [resultIDYoutube._id],
            type: 'YOUTUBE',
          });

          let newLectures = this.lectures.map((lecture) => lecture._id);
          newLectures.push(result._id);

          this.reload();
          this.closeDialog();
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];

          if (this.url !== this.urlID) {
            await updateYoutube({
              urlyoutube: this.url,
              idyoutube: [this.youtube_id],
            });

            await updateLecture({
              ...currentLecture,
              id: this.lectureId,
              title: this.title,
              description: this.description,
              youtube: [this.youtube_id],
              type: 'YOUTUBE',
            });
            // this.reload(result);
            // this.closeDialog();
          } else {
            await updateLecture({
              ...currentLecture,
              id: this.lectureId,
              title: this.title,
              description: this.description,
              youtube: [this.youtube_id],
              type: 'YOUTUBE',
            });
            // this.reload(result);
            // this.closeDialog();
          }
        }
        this.closeLectureDialog();
      } else {
        console.log('not pass');
      }
    },
    async showPreview() {
      // let resultPreview = await getPreviewYoutube();
      let tempIDYoutube = this.url.split('v=');
      let tempIDYoutubeByAmper = this.url.split('&');
      let tempIDYoutubeBySlash = this.url.split('/');
      if (tempIDYoutube.length > 1) {
        var video_id = tempIDYoutube[1];
        var ampersandPosition = video_id.indexOf('&');
        if (ampersandPosition != -1) {
          video_id = video_id.substring(0, ampersandPosition);
        }
        this.youtubeID = video_id;
        this.urlID = this.urlPreviewTemplate + this.youtubeID;
        this.preview = true;
      } else if (tempIDYoutube.length < 2 && tempIDYoutubeByAmper.length > 1) {
        video_id = tempIDYoutubeByAmper[0];
        this.youtubeID = video_id;
        this.urlID = this.urlPreviewTemplate + this.youtubeID;
        this.preview = true;
      } else if (tempIDYoutube.length < 2 && tempIDYoutubeBySlash.length > 1) {
        video_id =
          tempIDYoutubeBySlash[3] == 'embed'
            ? tempIDYoutubeBySlash[4]
            : tempIDYoutubeBySlash[3];
        this.youtubeID = video_id;
        this.urlID = this.urlPreviewTemplate + this.youtubeID;
        this.preview = true;
      } else {
        this.urlID = this.urlPreviewTemplate + this.url;
        // this.dialogInsertYoutubeFail = true;
      }
    },
    clearPreview() {
      this.urlID = '';
    },
    checkToSave() {
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.url !== this.urlID
          ? (this.warnningToSaveDialog = true)
          : ((this.isCheckComplete = false), this.closeLectureDialog());
      } else {
        this.title || this.description || this.url
          ? (this.warnningToSaveDialog = true)
          : ((this.isCheckComplete = false), this.closeLectureDialog());
      }
    },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.enableBR = false;
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: 350px;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
